import React from "react"
import "./barHoriRelative.less"
const color = [
  "rgba(133, 96, 248, 1)",
  "rgba(50, 156, 255, 1)",
  "rgba(110, 237, 178, 1)",
  "rgba(246, 255, 106, 1)",
  "rgba(255, 164, 70, 1)",
]
export default function BarHoriRelative({ list }) {
  let max = 1
  list.forEach(d => {
    if (d.value > max) max = d.value
  })
  return (
    <div className="ct-bar-hori-relative">
      <div className="ls-item">
        {list.map((item, i) => {
          let c = color[i % color.length]
          return (
            <div className="item" key={i}>
              <div className="item-name">
                <span>{item.name}</span>
              </div>
              <div className="bg">
                <div
                  className="bg-idx"
                  style={{
                    backgroundColor: c,
                    width: (item.value / max) * 100 + "%",
                  }}
                />
              </div>
              <div className="item-num">
                <span />
                {item.value}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
